<template>
  <section class="home-banner">
    <!-- <img
      src="@/assets/images/Belfast/HeroHeader/herobgmobile.png"
      class="hero-animation responsive-img hide-on-med-and-down"
    /> -->
   <Header/>
    <!-- <img src="@/assets/images/a141/home/heroMobile.png" /> -->
    <div class="container">
      <div class="banner-box">
        <h1>
          Belfast Rapid Transit<br />
          Phase 2
        </h1>
        
        <h5>Public Consultation on Route Options</h5>
        
        <hr/>
        <br/>
        <p>
          The consultation period is from Monday <b>26th July</b> to Monday <b>4th October 2021</b>.
        </p>
        <div class="banner-links">
          <div class="row">
            <div class="col">
              <a href="#section2"
                ><button class="link1">Learn More</button></a
              >
            </div>
            <div class="col">
              <a class="cta cta-bg-purple" href="/site/haveYourSay"
                ><button class="link2">Have Your Say</button></a
              >
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
 import Header from "@/components/belfast/Header";
export default {
  name: "home-hero-header",
  components: {
  
    Header,
   

  },
};
</script>
<style lang="scss">
</style>